import moment from 'moment';
import _ from 'underscore';

const addDayOffRequest = async ({ state, date, isApprover, resourceDayType, dayTypesAll, allowTourDayTypes, updateState }) => {
  const { resource, itemDetails } = state;
  if (resourceDayType.dayTypeId) { // there is an existing dayType on that day
    itemDetails.dayTypeId = resourceDayType.dayTypeId;  // seems like REG, dayTypeId 1 and others never appear on dayTypesAll list
  }
  // update itemDetails w/ resourceDayType field values
  itemDetails.date = date;
  itemDetails.dayTypeId = resourceDayType.dayTypeId;
  itemDetails.dayTypeComment = resourceDayType.comment || " ";
  itemDetails.myDayTypeComment = resourceDayType.myComment || " ";
  itemDetails.resourceDayType = resourceDayType;

  updateState({
    resource,
    allowTourDayTypes,
    dayTypesAll, // need to load all dropdown lists into state here
    itemDetails,
    isApprover,
  });

}

export default addDayOffRequest;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/loadItemData/addDayOffRequest.js